<div class="col-sm-2 amenities-filter">
    <div class="amenities-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <spinner [spinnerShow]="showDropdown && spinnerShow"></spinner>
    <div class="amenities-filter_dropdown" [hidden]="!showDropdown || spinnerShow">
        <div class="amenities-filter-items-wrapper">
            <div class="m-b-xs filter-checkbox" *ngFor="let amenity of amenitiesService.amenitiesList; let index = index;">
                <label class="img-checkbox">
                    <input type="checkbox" id="{{amenity.id}}" [attr.checked]="amenity.checked ? '' : null" (change)="timeOutBeforeFilterChanging()">
                    <label for="{{amenity.id}}"><svg-checked></svg-checked></label>
                    <span>{{amenity.name}}</span>
                </label>
                <div *ngIf="amenitiesService.view == 'calendar' && !authenticationService.userIsResident" class="amenity-color"
                     [ngStyle]="{'background-color' : (amenity.amenityColor ? amenity.amenityColor : '#1ab394')}"
                     [matMenuTriggerFor]="menu" (click)="amenityForColorChanging = amenity"></div>
            </div>
        </div>

        <hr *ngIf="!authenticationService.userIsResident">

        <div [ngStyle]="{'display':authenticationService.userIsResident? 'none': 'block'}" class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="approvedCheckbox" #approvedCheckbox (change)="changeFilter()">
                <label for="approvedCheckbox"><svg-checked></svg-checked></label>
                <span>Approved</span>
            </label>
        </div>

        <div [ngStyle]="{'display':authenticationService.userIsResident? 'none': 'block'}"class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="pendingCheckbox" #pendingCheckbox (change)="changeFilter()">
                <label for="pendingCheckbox"><svg-checked></svg-checked></label>
                <span>Pending</span>
            </label>
        </div>

        <div [ngStyle]="{'display':authenticationService.userIsResident? 'none': 'block'}"class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="expiredCheckbox" #expiredCheckbox (change)="changeFilter()">
                <label for="expiredCheckbox"><svg-checked></svg-checked></label>
                <span>Expired</span>
            </label>
        </div>

        <div [ngStyle]="{'display':authenticationService.userIsResident? 'none': 'block'}" class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="declinedCheckbox" #declinedCheckbox (change)="changeFilter()">
                <label for="declinedCheckbox"><svg-checked></svg-checked></label>
                <span>Declined</span>
            </label>
        </div>

    </div>
    <mat-menu #menu="matMenu" class="amenities-filter-menu">
        <mat-grid-list class="amenities-filter-colors-table-container" cols="5" rowHeight="1:1">
            <div class="colors-table-header">Select a color:</div>
            <mat-grid-tile *ngFor="let color of colorPallet">
                <div class="bookings-filter-colors-table-item"
                     [ngClass]="{'active' : color == amenityForColorChanging?.amenityColor}"
                     (click)="updateAmenityColor(color)"
                     [ngStyle]="{'background-color': color}">
                     <div [ngStyle]="{'background' : color != '#000000' ? 'rgba(0,0,0,0.3)' : 'rgba(255, 255, 255, 0.3)'}">
                         <i class="fa fa-check"></i>
                     </div>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </mat-menu>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/amenities-filter/amenities-filter.component.html